import { COLORS, FONTS } from '../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');

  return {
    root: {
      backgroundColor: COLORS.WHITE,
      padding: '20px 0 0 0',
      [minSm]: {
        padding: '40px 0 0 0',
      },
      marginTop: 56,
      [minSm]: {
        marginTop: 64,
        marginLeft: 200,
        width: 'calc(100vw - 200px)',
      },
    },
    innerWrapper: {
      maxWidth: 1200,
      margin: '0 auto',
    },
    headerWrapper: {
      padding: '0 0 30px 0',
      borderBottom: `10px solid ${COLORS.WHITE_DARK}`,
      [minSm]: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 30px 30px 30px',
        borderBottom: 'none',
      },
    },
    heading: {
      fontFamily: FONTS.SECONDARY,
      color: COLORS.GREY_DARK,
      fontWeight: 100,
      marginTop: 0,
      marginBottom: 0,
      textAlign: 'center',
      [minSm]: {
        textAlign: 'left',
      },
    },
    statsWrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
    statsWrapperCount: {
      textAlign: 'center',
      padding: '0 10px',
    },
    statsTitle: {
      fontSize: '0.875rem',
      fontWeight: 300,
      fontFamily: FONTS.PRIMARY,
      whiteSpace: 'nowrap',
      margin: 3,
      [minSm]: {
        fontSize: '1.2rem',
      },
      [minMd]: {
        fontSize: '1.5rem',
      },
    },
    statsNumber: {
      fontFamily: FONTS.SECONDARY,
      fontSize: '1.125rem',
      fontWeight: 900,
      lineHeight: 0.96,
      margin: 3,
      [minSm]: {
        fontSize: '1.8rem',
      },
      [minMd]: {
        fontSize: '2.1625rem',
      },
    },
    nav: {
      display: 'block',
      fontFamily: FONTS.PRIMARY,
      listStyle: 'none',
      textTransform: 'uppercase',
      margin: 0,
      backgroundColor: COLORS.WHITE_DARK,

      '& li': {
        display: 'inline-block',
        marginRight: 30,
        '& a': {
          color: COLORS.GREY_DARK,
          textDecoration: 'none',
          fontWeight: 500,
          letterSpacing: '1.5px',
          display: 'block',
          paddingBottom: 10,
        },
      },
      fontSize: '0.875rem',
      padding: '10px 30px 0 30px',
      [minSm]: {
        backgroundColor: COLORS.WHITE,
        padding: '0 30px 0 30px',
      },
    },
    activeLink: {
      borderBottom: `4px solid ${COLORS.GREEN}`,
    },
  };
};

export default styles;
